import strings from "translate/language";
import { errorToast, infoToast, successToast } from "utils/toastNotify";

function resolveMdocMessage(mdoc) {
  if (mdoc.code === "success") {
    return strings.mdocSyncSuccessMessage;
  }
  if (mdoc.code === "dry_run") {
    return strings.mdocSyncDryRunMessage;
  }
  if (mdoc.code === "validation_failed") {
    return mdoc.message || strings.mdocSyncValidationFailedMessage;
  }
  if (mdoc.code === "failed") {
    return mdoc.message || strings.mdocSyncFailedMessage;
  }
  return mdoc.message || strings.mdocSyncFailedMessage;
}

function resolveMdocTitle(mdoc) {
  if (mdoc.variant === "success" || mdoc.code === "success") {
    return strings.mdocSyncSuccessTitle;
  }
  if (mdoc.variant === "info" || mdoc.code === "dry_run") {
    return strings.mdocSyncDryRunTitle;
  }
  return strings.mdocSyncFailedTitle;
}

/** Show toast when API returns `mdoc` sync feedback. No-op if sync was not attempted. */
export function showMdocSyncFeedback(mdoc) {
  if (!mdoc?.attempted) {
    return;
  }

  const message = resolveMdocMessage(mdoc);
  const title = resolveMdocTitle(mdoc);

  if (mdoc.variant === "success" || mdoc.code === "success") {
    successToast(message, { title });
    return;
  }
  if (mdoc.variant === "info" || mdoc.code === "dry_run") {
    infoToast(message, { title });
    return;
  }
  errorToast(message, { title });
}

/** Show the primary action toast, then a dedicated M-Doc success/error toast when sync was attempted. */
export function showActionSuccessWithMdoc(primaryMessage, mdoc, options = {}) {
  const primary =
    String(primaryMessage ?? "").trim() || strings.toastSuccessTitle || "Success";
  successToast(primary, options);

  if (!mdoc?.attempted) {
    return;
  }

  setTimeout(() => showMdocSyncFeedback(mdoc), 120);
}
